module.exports = __webpack_public_path__ + "img/credit.97ee5103.svg";